module.exports = __webpack_public_path__ + "img/ABL-Friction-HSV-min.b201c70e.png";